import React, { Component } from 'react'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Input, Modal } from 'hljd'
import { REGEX_PHONE } from '@constant'

const Item = Form.Item

const formItemLayout = {
  labelCol: {
    xs: { span: 4 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 18 },
    sm: { span: 18 }
  }
}

@Form.create()
@observer
export default class extends Component {
  saveVerify = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.store.save(values)
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { msgBoxModalVisible, closeMsgBoxModal } = this.props.store

    return msgBoxModalVisible ? (
      <Modal
        title="给我留言"
        visible={msgBoxModalVisible}
        onOk={this.saveVerify}
        onCancel={closeMsgBoxModal}
      >
        <div className={styles.writeTel}>
          <Form>
            <Item label="问题描述" {...formItemLayout}>
              {getFieldDecorator('content', {
                initialValue: '',
                rules: [
                  { required: true, message: '问题描述必填' },
                  { max: 200, min: 1, message: '字数在200字以内' }
                ]
              })(
                <div className={styles.item}>
                  <Input.TextArea
                    placeholder="请简述您遇到的问题，我将在方便的时间尽快回复您"
                    rows={4}
                  />
                </div>
              )}
            </Item>
            <Item label="联系电话" {...formItemLayout}>
              {getFieldDecorator('phone', {
                initialValue: '',
                rules: [
                  { required: true, message: '手机号必填' },
                  { pattern: REGEX_PHONE, message: '手机号格式不正确' }
                ]
              })(<Input />)}
            </Item>
          </Form>
        </div>
      </Modal>
    ) : null
  }
}
